import { useModel, useParams } from "@bcm-dev/bcms-vite";
import ABI22PageIframeView from "components/shared/views/ABI22PageIframeView";
import PhoneWrapper from "components/shared/wrappers/PhoneWrapper";
import React, { useEffect, useState } from "react";
import "./styles.css";

/**
 * 
 * @function PageContainer 
 * @returns {React.Component}
 * @param {STRING} className - Additional classes to add to the PageContainer, usually the page wrapper class.
 * @exported true
 * @description The main page container for all pages.
 * @example 
 * <PageContainer className="login-page">
 *  <p>Login Page</p>
 * </PageContainer>
 */
export default function PageContainer(props) {
  const className = props.className ?? "";
  const {nowrapper} = useParams();
const noWrapper = nowrapper === "nowrapper";

const [src, setSrc]  = useState({route:props.page,key:Date.now()});
const { b, branding } = useModel();
const course = branding.options.abi22_courseid_mabi23;
const origin =  window.location.origin.indexOf("localhost") !== -1 ?`http://${window.location.hostname}:${parseInt(window.location.port)+1}` :window.location.origin+`${window.location.pathname.replace("mabi23","abi22")}?b=${ b }&c=${ course }`;
const [ fullPageIframe, setFullPageIframe ] = useState({ show: false, abi22Route: "" });
const [ loadPlaceholderABI22, setLoadPlaceholderABI22 ] = useState(props.loadPlaceholderABI22 ?? false);

// "useEffect" code here is primary used to handle postMessages from child iframes.
useEffect(() => {

    // Function that opens ORIG19 OR ORIG20 in a MABI23 phone wrapper in a new tab.
    // The event listener associated with this function is called by ABI22 inside of MABI23
    // when the "Open Account" link is clicked.
    const openORIGInMABI23 = evt => {
      if(evt.data.message === "openORIGInMABI23") {
        window.open(window.location.href.slice(0, window.location.href.indexOf("#")) + "#/noFooter/orig", "_blank");  
      }
    };
    
    const openChat = evt => {
      if(evt.data.message === "openMabiChat") {
        window.open(window.location.href.slice(0, window.location.href.indexOf("#")) + "#/noFooter/chatWorkflow", "_blank");  
      }
    }

    // Function that opens EDE Statements in a MABI23 phone wrapper in a new tab.
    // The event listener associated with this function is called by ABI22 inside of MABI23
    // when the "Statements" link is clicked.
    const openEDEStatements = evt => {
      if(evt.data.message === "openEDEStatements") {
        window.open(window.location.href.slice(0, window.location.href.indexOf("#")) + "#/noFooter/edeStatements", "_blank");  
      }
    }

    const openCH21Standalone = evt => {
      if(evt.data.message === "openABI22StandaloneIframe") {
        setFullPageIframe({ show: true, abi22Route: evt.data.pageID });
      }
    }
    const closeCH21Standalone = evt => {
      if(evt.data.message === "closeABI22StandaloneIframe") {
        setFullPageIframe({ show: false, abi22Route: undefined });
      }
    }

    // Function that closes the current MABI23 window. 
    // Currently used when the ABI23 EDE Statements "Sign Out" menu button is clicked.
    const closeWindowInMABI23 = evt => {
      if(evt.data.message === "closeWindowInMABI23") window.close();
    };
    
    window.addEventListener("message", openChat);
    window.addEventListener("message", openEDEStatements);
    window.addEventListener("message", openORIGInMABI23);
    window.addEventListener("message", openCH21Standalone);
    window.addEventListener("message", closeCH21Standalone);
    window.addEventListener("message", closeWindowInMABI23);

    return () => {
      window.removeEventListener("message", openChat);
      window.removeEventListener("message", openEDEStatements);
      window.removeEventListener("message", openORIGInMABI23);
      window.removeEventListener("message", openCH21Standalone);
      window.removeEventListener("message", closeCH21Standalone);
      window.removeEventListener("message", closeWindowInMABI23);
    };
  }, []);

  return (
    <>
     { !noWrapper &&  
      <PhoneWrapper>
        <div className={className + ` page-container`}>
          { fullPageIframe.show === true &&
          <ABI22PageIframeView srcKey={ src.key } src= { `${ origin }/#/${ fullPageIframe.abi22Route }` } />
          }
          { props.children }
        </div>
      </PhoneWrapper>
    }
    {
      noWrapper &&
        <>
          <div className={className + ` page-container`}>
            { fullPageIframe.show === true &&
            <ABI22PageIframeView srcKey={ src.key } src= { `${ origin }/#/${ fullPageIframe.abi22Route }` } />
            }
            { props.children }
          </div>  
        </>        
     }
    </>
  );
}